<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header"
    :class="{ 'align-items-center': showPoyDetailsDocs }"
  >

    <!-- Content Left -->
    <b-col
      class="content-header-left"
      :class="showPoyDetailsDocs ? 'mb-1' : 'mb-2'"
      :cols="showPoyDetailsDocs ? null : 12"
      :md="showPoyDetailsDocs ? null : 9"
    >
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <h2 class="content-header-title float-left pr-1 mb-0">
            {{ $t($route.meta.pageTitle) }}
          </h2>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <b-breadcrumb-item to="/">
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-for="item in $route.meta.breadcrumb"
                :key="item.text"
                :active="item.active"
                :to="item.to"
              >
                {{ $t(item.text) }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- Content Right -->
    <b-col
      class="content-header-right text-md-right mb-1"
      :class="showPoyDetailsDocs ? 'd-flex align-items-center ml-auto' : 'd-md-block d-none'"
      :md="showPoyDetailsDocs ? null : 3"
      :cols="showPoyDetailsDocs ? 'auto' : 12"
    >
      <b-button
        v-if="showPoyDetailsDocs"
        :to="{ name: 'poy-details-docs' }"
        :aria-label="$t('poyDetailsDocs.title')"
        variant="outline-primary"
        class="d-inline-flex align-items-center mr-50 text-nowrap"
      >
        <feather-icon
          icon="BookOpenIcon"
          class="mr-50"
        />
        {{ $t('poyDetailsDocs.open') }}
      </b-button>
      <b-dropdown
        variant="link"
        no-caret
        toggle-class="p-0"
        right
      >

        <template #button-content>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="btn-icon"
          >
            <feather-icon icon="SettingsIcon" />
          </b-button>
        </template>

        <!--        <b-dropdown-item :to="{ name: 'apps-todo' }">-->
        <!--          <feather-icon-->
        <!--            icon="CheckSquareIcon"-->
        <!--            size="16"-->
        <!--          />-->
        <!--          <span class="align-middle ml-50">Todo</span>-->
        <!--        </b-dropdown-item>-->

        <b-dropdown-item
          v-if="$can('update','member')"
          :to="{ name: 'add-agent' }"
        >
          <feather-icon
            icon="UsersIcon"
            size="16"
          />
          <span class="align-middle ml-50">{{ $t('Add Agent') }}</span>
        </b-dropdown-item>

        <b-dropdown-item
          v-if="$can('read','lotto') || $can('update','lotto')"
          :to="{ name: 'lotto-list' }"
        >
          <feather-icon
            icon="ListIcon"
            size="16"
          />
          <span class="align-middle ml-50">{{ $t('Lotto List') }}</span>
        </b-dropdown-item>

        <b-dropdown-item
          v-if="$can('read','api') || $can('update','api')"
          :to="{ name: 'api-setting' }"
        >
          <feather-icon
            icon="SettingsIcon"
            size="16"
          />
          <span class="align-middle ml-50">{{ $t('Api Setting') }}</span>
        </b-dropdown-item>
        <b-dropdown-item
          v-if="$can('update','agent')"
          :to="{ name: 'my-account' }"
        >
          <feather-icon
            icon="UserIcon"
            size="16"
          />
          <span class="align-middle ml-50">{{ $t('My Account') }}</span>
        </b-dropdown-item>
      </b-dropdown>
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
  },
  computed: {
    showPoyDetailsDocs() {
      return this.$route.name === 'api-setting' && this.$store.getters['app/canReadPoyDetailsDocs']
    },
  },
}
</script>
